import * as z from 'zod'

/**
 * Password validation schema that enforces:
 * - Minimum 12 characters
 * - At least 1 uppercase letter
 * - At least 1 lowercase letter
 * - At least 1 number
 */
export const passwordValidation = z
    .string()
    .min(12, "Password must be at least 12 characters")
    .regex(/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{12,}$/, {
        message: "Password must contain at least one uppercase letter, one lowercase letter, and one number",
    })


